__turbopack_context__.v({
  "container": "styles-module-scss-module__XGnKAG__container",
  "root": "styles-module-scss-module__XGnKAG__root",
  "rootDarkMode": "styles-module-scss-module__XGnKAG__rootDarkMode",
  "shareUrl": "styles-module-scss-module__XGnKAG__shareUrl",
  "shareWrapper": "styles-module-scss-module__XGnKAG__shareWrapper",
  "title": "styles-module-scss-module__XGnKAG__title",
  "titleDarkMode": "styles-module-scss-module__XGnKAG__titleDarkMode",
});
